import React from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import ProductController from "../controllers/ProductController";
import { TCommissionRuleProduct } from "../types/CommissionRule";
import { TAffiliatedCommission } from "../types/Affiliated";
import AffiliationController from "../controllers/AffiliationController";

export interface IProductAffiliationsProps {
    id: string;
}

export const useAffiliationsCommissions = ({ id }: IProductAffiliationsProps) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<TAffiliatedCommission[]>([]);
    const [error, setError] = React.useState<string>('');

    const execute = async () => {
        if (!loading) {
            try {
                setLoading(true);

                if (error !== '') {
                    setError('');
                }

                const response = await AffiliationController.getAffiliationCommissions({ id });
                const responseError = response as IErrorResponse;
                const responseData = response as TAffiliatedCommission[];

                if (responseError.code) {
                    setError(responseError.error);
                    setData([]);
                } else {
                    setData(responseData);
                }
            } catch (e) {
                var message = 'Erro não identificado';
                if (typeof e === "string") {
                    message = e.toUpperCase();
                } else if (e instanceof Error) {
                    const err = e as Error;
                    message = err.message;
                }
                setError(message);
            } finally {
                setLoading(false);
            }
        }
    }

    React.useEffect(() => {
        execute();
    }, []);

    const clear = () => {
        setError('');
    }

    return {
        loading,
        data,
        error,
        execute,
        clear,
    };
}